export default __webpack_public_path__ + "035a165f2301d828d119a3b0ef94420e.png";